export function FindUnderUserById(UnderUsers, underUserId) {
    return UnderUsers.find(underUser => underUser.idUnderUser === underUserId);
}
